export { default as SuggestPart } from "./SuggestPart.vue"